import type { IconSvgObject } from './types';

const TextCircleIcon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 17H10.5M12 7L12 17M8 8.5V8C8 7.44772 8.44772 7 9 7H15C15.5523 7 16 7.44772 16 8V8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TextCircleIcon;
